import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../Button/Button';
import Icon from '../Icon/Icon';
import Modal from '../Modal';
import styles from './DeleteSharedVideoModal.module.scss';

function DeleteSharedVideoModal({ video, videos, confirmDeletion, isShow, onClose }) {
  const { t } = useTranslation();

  const generateVideosName = () => {
    if (video?.name) {
      return `"${video.name}"`;
    }

    return videos?.map(({ name }, index) => {
      if (index === 0) {
        return `"${name}"`;
      }

      return `, "${name}"`;
    });
  };

  const handleDelete = () => {
    confirmDeletion(true);
    onClose();
  };

  return (
    <Modal className={styles.modal} open={isShow} onClose={onClose}>
      <div className={styles.container}>
        <div className={styles.modalHeader}>
          <span className={styles.modalTitle}>{t('delete_shared_video_modal.header')}</span>
          <Icon src="close" className={styles.closeIcon} onClick={onClose} />
        </div>
        <div className={styles.text}>
          <span>
            {t('delete_shared_video_modal.first_text')} {generateVideosName()} ? {t('delete_shared_video_modal.second_text')}
          </span>
        </div>
        <div className={styles.buttonsContainer}>
          <CustomButton variant="secondary" label={t('general.cancel')} onClick={onClose} />
          <CustomButton className={styles.removeBtn} variant="primary" label={t('general.remove')} onClick={handleDelete} />
        </div>
      </div>
    </Modal>
  );
}

export default DeleteSharedVideoModal;
